
import { useNavigate, useParams } from "react-router-dom";
import { Section } from "../components/styled/Containers.style";
import { PageTitle, TextDefault } from "../components/styled/Text.style";
import { Vspace } from '../components/styled/Separators.style'
import { composeUrl } from "../utils/utils";
import { PATHS } from "../routes/CaiExperienceRouter";
import PageContainerCmp from "./PageContainerCmp";
import FotoCartaCircolazione from "../components/foto-carta-circolazione/FotoCartaCircolazione";
import { useAppSelector } from "../store/hooks";
import { selectCommunicationData } from "../store";

/* istanbul ignore next */
const Trct_FotoCartaCircolazionePage = () => {
    let navigate = useNavigate();
    let { token } = useParams();
    const communicationData = useAppSelector(selectCommunicationData)
    const { communication } = communicationData
    const nextBtnDisabled = !communication?.fotoCartaCircolazione || communication.fotoCartaCircolazione.length < 2;

    const goToNextStepHandler = () => {
        navigate(composeUrl(token, PATHS.TRCT_FOTO_PATENTE))
    }

    return (
        <>
            <PageContainerCmp
                nextStepHandler={goToNextStepHandler}
                routePath={PATHS.TRCT_FOTO_CARTA_CIRCOLAZIONE}
                nextDisabled={nextBtnDisabled}
            >
                <>
                    <Section>
                        <PageTitle>Foto della carta di circolazione</PageTitle>
                        <Vspace></Vspace>
                        <TextDefault centered>Assicurati che il documento risulti leggibile e ben illuminato. Non è possibile fotografare fotocopie.</TextDefault>
                    </Section>

                    <FotoCartaCircolazione
                        onTotFotoIsRiched={goToNextStepHandler} />
                </>
            </PageContainerCmp>
        </>

    )
}

export default Trct_FotoCartaCircolazionePage